import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { withTranslation, Trans } from 'react-i18next';

// redux
import { push } from '../../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class UserProfileBuilder extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.completionTimeout = setTimeout(this.complete, 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.completionTimeout);
  }

  goToProfile = () => {
    this.props.changePage('/account/profile');
    this.complete();
  }

  complete = () => {
    if (this.props.onCompleted) {
      this.props.onCompleted();
    }
  }

  // render
  render() {
    return (
      <Trans i18nKey='ProfileBuilderThankYouMessage'>
        <h1>Thank you!</h1>
        <div>You can always update your profile <Link to='/account/profile' onClick={this.goToProfile}>here</Link>.</div>
      </Trans>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(UserProfileBuilder)));
